<template>
    <div class="main">
        <c-panel title="DISTRIBUIÇÃO DE PASSES (MENSAL)" titleIcon="fas fa-bus">

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :sm="5">
                        <el-form-item label="Mês de referência">
                            <el-date-picker v-model="mesReferencia" type="month" format="MM/yyyy" value-format="yyyy-MM" style="width:100%;" @change="load"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="5">
                        <el-form-item label="Tipo de passe (filtro)">
                            <el-select v-model="tipoPasseId" filterable clearable placeholder="Todos" style="width:100%;" @change="load">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="14" style="padding-top:25px;" class="u-text-right">
                        <el-button type="primary" icon="el-icon-plus" @click="abrirLote" :disabled="!mesReferencia">DISTRIBUIR EM LOTE</el-button>
                        <el-button type="primary" plain icon="el-icon-printer" @click="imprimir" :disabled="!mesReferencia">IMPRIMIR</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :sm="24" class="u-text-right">
                        <strong>Total no mês:</strong> {{ totalQuantidade }} passes · {{ items.length }} alunos
                    </el-col>
                </el-row>
            </el-form>

            <table class="table table-striped">
                <thead><tr>
                    <th style="width:70px;">Cod</th>
                    <th>Aluno</th>
                    <th>Tipo</th>
                    <th style="width:120px;">Mês</th>
                    <th style="width:90px;" class="u-text-right">Qtd</th>
                    <th style="width:120px;">Entrega</th>
                    <th style="width:120px;" class="u-text-center">Ações</th>
                </tr></thead>
                <tbody>
                    <tr v-for="d in items" :key="d.id">
                        <td>{{ d.id }}</td>
                        <td>{{ d.aluno ? d.aluno.nome : '—' }}</td>
                        <td>{{ d.tipo_passe ? d.tipo_passe.nome : '—' }}</td>
                        <td>{{ d.mes_referencia }}</td>
                        <td class="u-text-right">{{ d.quantidade }}</td>
                        <td>{{ d.data_entrega | formatarData }}</td>
                        <td class="u-text-center">
                            <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(d.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="7" class="u-text-center" style="color:#909399;padding:15px;">Nenhuma distribuição no mês selecionado.</td>
                    </tr>
                </tbody>
            </table>

            <!-- Modal: distribuir em lote -->
            <el-dialog title="Distribuir em lote" :visible.sync="modalLoteVisivel" width="800px">
                <el-form label-position="top">
                    <!-- Instituição só aparece quando não houve pré-seleção (SMED) -->
                    <el-row :gutter="10" class="u-mt-20">
                        <el-col :sm="24">
                            <div class="u-text-right">
                                <strong>Mês:</strong> {{ mesReferencia }}
                            </div>
                        </el-col>
                        <el-col :sm="24">
                            <el-form-item label="Instituição">
                                <el-select v-model="formLote.instituicao_id" filterable placeholder="Selecione a instituição" style="width:100%;">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :sm="12">
                            <el-form-item label="Tipo de passe">
                                <el-select v-model="formLote.tipo_passe_id" filterable placeholder="Selecione o tipo" style="width:100%;">
                                    <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12">
                            <el-form-item label="Data de entrega">
                                <el-date-picker v-model="dataEntregaLote" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <h4>Adicionar alunos</h4>
                    <table class="table">
                        <thead><tr><th>Aluno</th><th style="width:120px;">Quantidade</th><th>Observação</th><th style="width:60px;"></th></tr></thead>
                        <tbody>
                            <tr v-for="(a, i) in formLote.alunos" :key="i">
                                <td>
                                    <el-select v-model="a.aluno_id" filterable remote :remote-method="q => buscarAluno(q, i)" placeholder="Digite..." style="width:100%;">
                                        <el-option v-for="al in (alunosBuscaPorLinha[i] || [])" :key="al.id" :label="al.nome" :value="al.id"></el-option>
                                    </el-select>
                                </td>
                                <td><el-input-number v-model="a.quantidade" :min="1" :max="100" style="width:100%;"></el-input-number></td>
                                <td><el-input v-model="a.observacao" size="small"></el-input></td>
                                <td><el-button size="mini" type="danger" plain icon="el-icon-delete" @click="formLote.alunos.splice(i, 1)"></el-button></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="u-text-right u-mt-10">
                        <el-button size="small" plain icon="el-icon-plus" @click="formLote.alunos.push({ aluno_id: null, quantidade: 22, observacao: '' })">+ ALUNO</el-button>
                    </div>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalLoteVisivel = false">CANCELAR</el-button>
                    <el-button type="primary" @click="confirmarLote">CONFIRMAR DISTRIBUIÇÃO</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data () {
        return {
            mesReferencia: moment().format('YYYY-MM'),
            tipoPasseId: null,
            tipos: [], items: [],
            modalLoteVisivel: false,
            formLote: { instituicao_id: null, tipo_passe_id: null, alunos: [{ aluno_id: null, quantidade: 22, observacao: '' }] },
            dataEntregaLote: null,
            alunosBuscaPorLinha: {}
        }
    },
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        totalQuantidade () { return this.items.reduce((s, i) => s + Number(i.quantidade || 0), 0) }
    },
    mounted () {
        this.carregarTipos()
        this.load()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        // Instituição da listagem/impressão: pré-selecionada para escola; para SMED fica vazia (todas).
        instId () {
            const i = this.$store.state.config.instituicao
            return (i && i.id) ? i.id : null
        },

        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/distribuicao-passe/imprimir',
                param: { instituicao_id: this.instId(), mes_referencia: this.mesReferencia, tipo_passe_id: this.tipoPasseId }
            })
        },

        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-passe/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
        },
        load () {
            if (!this.mesReferencia) { this.items = []; return }
            this.$axios.post(`${this.baseUrl()}/api/distribuicao-passe/getAllPaginate`,
                { instituicao_id: this.instId(), mes_referencia: this.mesReferencia, tipo_passe_id: this.tipoPasseId },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
              .catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$confirm('Excluir registro?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/distribuicao-passe/delete/${id}`, this.$store.getters.getHeaderAuth).then(() => this.load())
            }).catch(() => {})
        },

        abrirLote () {
            if (!this.mesReferencia) {
                window.eventBus.$emit('alert', { msg: 'Selecione o mês de referência.', type: 'warning' })
                return
            }
            this.formLote = {
                instituicao_id: this.instId(), // escola: pré-selecionada; SMED: null (escolhe no formulário)
                tipo_passe_id: this.tipoPasseId || null,
                alunos: [{ aluno_id: null, quantidade: 22, observacao: '' }]
            }
            this.dataEntregaLote = moment().format('YYYY-MM-DD')
            this.alunosBuscaPorLinha = {}
            this.modalLoteVisivel = true
        },
        buscarAluno (q, idx) {
            if (!q || q.length < 2) return
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.$set(this.alunosBuscaPorLinha, idx, r.data || []) })
        },
        confirmarLote () {
            if (!this.formLote.instituicao_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a instituição.', type: 'warning' })
                return
            }
            if (!this.formLote.tipo_passe_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione o tipo de passe.', type: 'warning' })
                return
            }
            const payload = {
                instituicao_id: this.formLote.instituicao_id,
                mes_referencia: this.mesReferencia,
                tipo_passe_id: this.formLote.tipo_passe_id,
                data_entrega: this.dataEntregaLote,
                alunos: this.formLote.alunos.filter(a => a.aluno_id && a.quantidade > 0)
            }
            if (!payload.alunos.length) {
                window.eventBus.$emit('alert', { msg: 'Adicione pelo menos um aluno com quantidade > 0.', type: 'warning' })
                return
            }
            this.$axios.post(`${this.baseUrl()}/api/distribuicao-passe/distribuirEmLote`, payload, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: `Distribuição concluída: ${r.data.criados} criados, ${r.data.atualizados} atualizados.`, type: 'success' })
                this.modalLoteVisivel = false
                this.load()
            })
        }
    }
}
</script>
